const getEnv = (name: string, isRequired?: boolean) => {
  const envVar = import.meta.env[name];
  if (!!isRequired && !envVar) {
    throw new Error(`Missing Environment Variable: ${name}`);
  }

  return envVar as string;
};

const variables = {
  syncfusionLicenseKey: getEnv("VITE_SYNCFUSION_LICENSE", true),
  apiBaseUrl: getEnv("VITE_API_BASE_URL", true),
  uiBaseUrl: getEnv("VITE_UI_BASE_URL", true),

  // Development Features
  enablePlaidTestControls: getEnv("VITE_ENABLE_PLAID_TEST_CONTROLS", false) === "true",

  // Consumer Auth0 Configuration
  consumerAuth0Domain: getEnv("VITE_CONSUMER_AUTH0_DOMAIN", true),
  consumerAuth0ClientId: getEnv("VITE_CONSUMER_AUTH0_CLIENT_ID", true),
  consumerAuth0RedirectUri: getEnv("VITE_CONSUMER_AUTH0_REDIRECT_URI", true),
  consumerAuth0Audience: getEnv("VITE_CONSUMER_AUTH0_AUDIENCE", true),
  consumerAuth0LogoutUri: getEnv("VITE_CONSUMER_AUTH0_LOGOUT_URI", true),
  consumerAuth0OrgId: getEnv("VITE_CONSUMER_AUTH0_ORG_ID", true),

  // Banker Auth0 Configuration
  bankerAuth0Domain: getEnv("VITE_BANKER_AUTH0_DOMAIN", true),
  bankerAuth0ClientId: getEnv("VITE_BANKER_AUTH0_CLIENT_ID", true),
  bankerAuth0RedirectUri: getEnv("VITE_BANKER_AUTH0_REDIRECT_URI", true),
  bankerAuth0Audience: getEnv("VITE_BANKER_AUTH0_AUDIENCE", true),
  bankerAuth0LogoutUri: getEnv("VITE_BANKER_AUTH0_LOGOUT_URI", true),
  bankerAuth0OrgId: getEnv("VITE_BANKER_AUTH0_ORG_ID", true),
};

export const getAuth0Config = (clientType: "consumer" | "banker") => {
  if (clientType === "consumer") {
    return {
      domain: variables.consumerAuth0Domain,
      clientId: variables.consumerAuth0ClientId,
      redirectUri: variables.consumerAuth0RedirectUri,
      audience: variables.consumerAuth0Audience,
      logoutUri: variables.consumerAuth0LogoutUri,
      orgId: variables.consumerAuth0OrgId,
    };
  } else {
    return {
      domain: variables.bankerAuth0Domain,
      clientId: variables.bankerAuth0ClientId,
      redirectUri: variables.bankerAuth0RedirectUri,
      audience: variables.bankerAuth0Audience,
      logoutUri: variables.bankerAuth0LogoutUri,
      orgId: variables.bankerAuth0OrgId,
    };
  }
};

export default variables;
